import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';
import Badges from 'modules/common/components/Badge';
import { useOpenViewTransaction } from 'modules/transactions/modals/ViewTransaction';
import { formatNumber } from 'helper';
import { Eye } from '@phosphor-icons/react';

const MAP_STATUS = {
  // TRANSFORM STATUS LABEL
  PAID: 'APPROVED',
};

const labelClassName = 'whitespace-nowrap';
const contentClassName = 'whitespace-nowrap';

export default function PaymentTransactions() {
  const { isLoading, list, meta, setPage } = useReportsContext();
  const viewTransaction = useOpenViewTransaction();

  const format = [
    {
      label: 'DATE OF TRANSACTION',
      key: 'created_at',
      contentClassName: 'tabular-nums text-neutral-500',
    },
    { label: 'AGENCY NAME', key: 'organization_name' },
    {
      id: 'updated_at',
      label: 'UPDATED AT',
      key: ({ status, updated_at }) => (
        <span>{status === 'DRAFT' ? '--' : updated_at}</span>
      ),
    },
    {
      id: 'refno',
      label: 'REFERENCE NO.',
      key: ({ status, refno }) => (
        <span>{status === 'DRAFT' ? '--' : refno}</span>
      ),
    },
    {
      id: 'balance',
      label: 'AMOUNT',
      key: ({ debit, credit }) => (
        <span>{formatNumber(+debit ? debit : credit, 0)}</span>
      ),
      labelClassName: 'pr-10 whitespace-nowrap flex justify-end',
      contentClassName: 'pr-10 whitespace-nowrap text-right',
    },
    {
      id: 'status',
      label: 'STATUS',
      key: ({ status }) => <Badges status={MAP_STATUS[status] || status} />,
    },
    {
      id: 'view',
      label: '',
      key: (item) => (
        <button
          type="button"
          onClick={() => viewTransaction(item)}
          className="p-px border-none hover:bg-brand-600 text-brand-600 hover:text-white rounded transition"
        >
          <Eye className="w-4 h-4" />
        </button>
      ),
    },
  ].map((item) => ({
    ...item,
    labelClassName,
    contentClassName,
  }));

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
